import * as React from 'react';

const Table24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M20.375 4.12451C21.8938 4.12451 23.125 5.35574 23.125 6.87451V17.8745C23.125 19.3933 21.8938 20.6245 20.375 20.6245H6.375C4.85622 20.6245 3.625 19.3933 3.625 17.8745V6.87451C3.62501 5.35574 4.85623 4.12452 6.375 4.12451H20.375ZM5.125 17.8745C5.125 18.5649 5.68465 19.1245 6.375 19.1245H12.625V15.6245H5.125V17.8745ZM14.125 19.1245H20.375C21.0654 19.1245 21.625 18.5649 21.625 17.8745V15.6245H14.125V19.1245ZM5.125 14.1245H12.625V10.6245H5.125V14.1245ZM14.125 14.1245H21.625V10.6245H14.125V14.1245ZM6.375 5.62451C5.68465 5.62452 5.12501 6.18417 5.125 6.87451V9.12451H12.625V5.62451H6.375ZM14.125 9.12451H21.625V6.87451C21.625 6.18416 21.0654 5.62451 20.375 5.62451H14.125V9.12451Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export default Table24;
